import { persistReducer, persistStore } from 'redux-persist'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import storage from 'redux-persist/lib/storage'
import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { courseReducer, coursesReducer, stateReducer, userReducer } from './slices'

const reducers = combineReducers({
  course: courseReducer,
  courses: coursesReducer,
  state: stateReducer,
  user: userReducer
})

const persistConfig = {
  key: 'root',
  whitelist: ['state', 'user'],
  storage,
  transforms: [],
  stateReconciler: autoMergeLevel2 as any
}

const persistedReducer = persistReducer(persistConfig, reducers)

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
